import React from 'react';
import classNames from 'classnames';

import RichTextArea from '../../../../design-system/RichTextArea/RichTextArea';
import { ButtonIcon } from '../../../../design-system';
import { ArrowDownSLineIcon, ArrowUpSLineIcon } from '../../../../design-system/Icons';

const GroupCollapsibleContainer = ({ title, description, isExpanded, toggleExpand, children }) => {
    const containerClassName = classNames(
        isExpanded ? 'pt-5 flex flex-col gap-5' : 'h-0 max-h-0 overflow-hidden'
    );

    return (
        <div className="border-b-1 border-neutral-200 pb-5 w-full">
            <div className="flex items-center justify-between gap-3">
                <p className="font-body-bold text-body-bold-m text-black uppercase">{title}</p>

                <ButtonIcon
                    size="sm"
                    type="link"
                    icon={isExpanded ? ArrowUpSLineIcon : ArrowDownSLineIcon}
                    onClick={toggleExpand}
                />
            </div>

            <div className={containerClassName}>
                {description && (
                    <div>
                        <RichTextArea
                            value={description}
                            previewOnly
                            autoExpand
                            isBorderHidden
                            previewMinHeight={30}
                        />
                    </div>
                )}

                {children}
            </div>
        </div>
    );
};

export default GroupCollapsibleContainer;
